import { ThemeComponent } from '@/theme/ThemeComponent';
import { OptionSelector } from '@/utils/OptionSelectors';
import { Component, Prop, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { ProductOption } from '@/components/Product/ProductOptionPicker';
import { debounce } from 'lodash';

interface ValueRadio extends HTMLInputElement {
    dataset: {
        value: string;
    };
}

@Component
export class ProductButtonOption extends ThemeComponent implements ProductOption {
    @Prop name!: string;
    @Prop selected!: string;
    @Prop position!: number;

    @Ref radioWrapper!: HTMLElement[];
    @Ref({required: false}) labelSelectedOption?: HTMLElement;

    private valuesWithoutStock: string[] = [];
    private valuesWithoutVariant: string[] = [];

    private _onChange = new SimpleEvent<string|null>();
    public get onChange() {
        return this._onChange.asEvent();
    }

    init() {
        for (const option of this.radioWrapper) {
            const button = option.querySelector('input') as ValueRadio;
            this.$listen(button, 'change', () => {
                if (!button.checked) { return; }

                const value = button.value;
                this.select(value);

                // Update label selected value
                if (this.labelSelectedOption && value) {
                    this.labelSelectedOption.textContent = value.toLowerCase();
                }

                this._onChange.dispatch(value);
            });
        }
        // this._onChange.dispatch(this.selected);
    }

    public select(value: string) {
        this.selected = value;
        this.updateButtonStyles();
    }

    public updateBasedOnSelector(selector: OptionSelector) {
        this.valuesWithoutStock = selector.options[this.position - 1].values
            .filter((v) => v.outOfStock).map((v) => v.value);
        this.valuesWithoutVariant = selector.options[this.position - 1].values
            .filter((v) => !v.variantExists).map((v) => v.value);

        setTimeout(() => {
            this.updateButtonStyles();
        }, 300);
    }

    private updateButtonStyles() {
        for (const option of this.radioWrapper) {
            const button = option.querySelector('input') as ValueRadio;
            const value = button.value ;
            const selected = (value || null) == this.selected;
            const outOfStock = this.valuesWithoutStock.indexOf(value) > -1;
            const noVariant = this.valuesWithoutVariant.indexOf(value) > -1;

            if (button.parentNode == null) { return; }

            const wrapper = button.parentNode as HTMLElement;

            wrapper.classList.remove(
                'product-button-option__button-item--active',
                'product-button-option__button-item--no-variant',
                'product-button-option__button-item--out-of-stock'
            );

            if (noVariant) {
                wrapper.classList.add('product-button-option__button-item--no-variant');
                return;
            }

            if (selected) {
                wrapper.classList.add('product-button-option__button-item--active');
            }

            if (outOfStock) {
                wrapper.classList.add('product-button-option__button-item--out-of-stock');
            }
        }
    }
}
